
import PropTypes from "prop-types"
import React, { useState,useEffect } from "react"
import LanguageSwitcher from "./LanguageSwitcher";
import { injectIntl } from "react-intl";
import Link from "../components/LocalizedLink";

import teddy from "../images/teddy.png";
import violetta from "../images/violetta@2x.png";
import julie from "../images/julie@2x.png";
import paul from "../images/paul.png";


const Header = ({ siteTitle, intl }) => {
    const [scrollPosition, setSrollPosition] = useState(0);
    const handleScroll = () => {
        const position = window.scrollY;
        setSrollPosition(position);
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const [drawer, setDrawer] = useState(false);
    const menuClass = (drawer ? 'show':'');
    const scrollClass = (scrollPosition > 100 ? 'scrolled':'')
    return(<header>
            <section className={scrollClass+" julie-header fixed-top"}>
                <div className="container">
                    <nav className="navbar navbar-expand-lg navbar-light">
                        {/*<a className="navbar-brand julie-logo" href="javascript:;" id="home" title="Julie Desk" />*/}
                        <Link className="navbar-brand julie-logo" to="/"></Link>
                        <button onClick={() => setDrawer(true)} className="navbar-toggler border-0" type="button" data-trigger="#main_nav">
                            <span className="navbar-toggler-icon"/>
                        </button>
                        <div className={menuClass +" navbar-collapse justify-content-end"} id="main_nav">
                            <div className="offcanvas-header mt-3">
                                <button onClick={() => setDrawer(false)} className="btn btn-close float-right"> x</button>
                                <h5 className="py-2"><a className="navbar-brand julie-logo popLogo" id="home"
                                                        href="/" title="Julie Desk"/>
                                </h5>
                            </div>
                            <ul className="navbar-nav">
                                <li className="nav-item dropdown" id="servicesId">
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{intl.formatMessage({id: "services"})}</a>
                                    <div className="dropdown-divider d-md-none"/>
                                    <div className="dropdown-menu menuHead c-box c-box--arrow-top"
                                         aria-labelledby="navbarDropdown">
                                        <Link className="dropdown-item julie" to="/julie">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col dp-inner-pad">
                                                        <img src={julie}/>
                                                    </div>
                                                    <div className="col-10 pad-20">
                                                        <h5>Julie</h5>
                                                        {/*<h6>{intl.formatMessage({id: "personal_assistant"})}</h6>*/}
                                                        <p>{intl.formatMessage({id: "besides_meetings_organization"})}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>     
                                        <Link className="dropdown-item teddy" to="/teddy">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col dp-inner-pad">
                                                        <img src={teddy}/>
                                                    </div>
                                                    <div className="col-10 pad-20">
                                                        <h5>Teddy</h5>
                                                        {/*<h6>{intl.formatMessage({id: "personal_assistant"})}t</h6>*/}
                                                        <p>{intl.formatMessage({id: "automated_meeting"})}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link className="dropdown-item violetta" to="/violetta">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col dp-inner-pad">
                                                        <img src={violetta}/>
                                                    </div>
                                                    <div className="col-10 pad-20">
                                                        <h5>Violetta</h5>
                                                        {/*<h6>{intl.formatMessage({id: "personal_assistant"})}</h6>*/}
                                                        <p>{intl.formatMessage({id: "takes_over"})}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                        <hr className="my-12"/>
                                        <Link className="dropdown-item paul" to="/paul">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col dp-inner-pad">
                                                        <img src={paul}/>
                                                    </div>
                                                    <div className="col-10 pad-20">
                                                        <h5>Paul</h5>
                                                        {/*<h6>{intl.formatMessage({id: "personal_assistant"})}</h6>*/}
                                                        <p>{intl.formatMessage({id: "a_solution_to_content"})}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                        {/*<a class="connect d-none d-md-block" href="#">
                                <span class="connect-span" data-localize="all_our_products">All our products</span>
                            </a>*/}
                                    </div>
                                </li>
                                <li className="nav-item">
                                    {/*<a className="nav-link price" href="javascript:;" id="price" data-localize="pricing">Pricing</a>*/}
                                    <Link className="nav-link price" to="/price">
                                        {intl.formatMessage({id: "price"})}
                                        {/* OR <FormattedMessage id="go_page2" /> */}
                                    </Link>
                                    <div className="dropdown-divider d-md-none"/>
                                </li>
                               {/* <li className="nav-item">
                                    <Link className="nav-link" to="/about">About</Link>
                                    <div className="dropdown-divider d-md-none"/>
                                </li>*/}
                                <li className="nav-item">
                                    <Link className="nav-link" to="/paul">{intl.formatMessage({id: "digital_marketing"})}</Link>
                                    <div className="dropdown-divider d-md-none"/>
                                </li>
                                <li className="nav-item d-none d-md-block cmMenuTop7 scrollHide">
                                    <Link className="mainBtn login-btn orangeBackground" id="login"
                                          to="/login"><span>{intl.formatMessage({id: "log_in"})}</span></Link>
                                </li>
                                <li className="nav-item cmMenuTop7 scrollShow">
                                    <a target="_blank" rel="noreferrer" href={process.env.GATSBY_CALENDLY_LINK}
                                       className="mainBtn login-btn mixBackground">
                                        <span>{intl.formatMessage({id: "get_in_touch"})}</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <LanguageSwitcher/>
                                </li>
                            </ul>
                            <div className="menuBack text-center d-sm-block d-md-none">
                                <a href="#" className="mainBtn mixBackground">
                                    <span>{intl.formatMessage({id: "start_you_free_trial"})}</span>
                                </a>
                                <p className="alreadyAccountText">
                                    {intl.formatMessage({id: "already_an_account"})}
                                </p>
                                <a href="/login" className="alreadyAccountTextA" id="login">{intl.formatMessage({id: "log_in"})}</a>
                            </div>
                        </div>
                    </nav>
                </div>
            </section>
        </header>
    )
}

Header.propTypes = {
    siteTitle: PropTypes.string,
}

Header.defaultProps = {
    siteTitle: ``,
}

export default injectIntl(Header);

